<template>
	<Popper v-click-outside="closePopup" :isVisible="isVisible" placement="top">
		<BaseTooltip :enabled="!isVisible && !disabled" text="Change playback rate" placement="top" class="h-20">
			<button
				class="h-20 flex items-center justify-end player-control-button"
				:disabled="disabled"
				@click="togglePopup"
			>
				<span class="block self-end font-mono text-sm font-bold text-right"> {{ playbackRate }}x </span>
				<span class="sr-only">Change playback rate</span>
			</button>
		</BaseTooltip>
		<template #popup>
			<menu
				class="py-4 font-mono text-sm font-semibold text-right text-white bg-black border rounded-lg shadow dark border-gray-650"
			>
				<li v-for="rate in playbackRates" :key="rate">
					<button
						class="px-8 hover:text-gray-100"
						:class="rate === playbackRate ? 'text-gray-300 font-bold' : 'text-gray-400'"
						@click="update(rate)"
					>
						{{ rate }}x
					</button>
				</li>
			</menu>
		</template>
	</Popper>
</template>

<script>
import Popper from './Popper.vue'

export default {
	name: 'VideoPlayerPlaybackRateControl',
	components: {Popper},
	props: {
		playbackRate: {
			type: Number,
			default: 1,
		},
		disabled: Boolean,
	},
	emits: ['update'],
	data() {
		return {
			isVisible: false,
			playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 2],
		}
	},
	methods: {
		update(rate) {
			this.$emit('update', rate)
			this.closePopup()
		},
		closePopup() {
			this.isVisible = false
		},
		togglePopup() {
			if (this.disabled) return
			if (this.isVisible) this.closePopup()
			else this.isVisible = true
		},
	},
}
</script>
